export default {
  // Keep Alive的路由
  keepAliveRoutes: [
    '/faceTracking'
  ],
}



//////////////////
// WEBPACK FOOTER
// ./src/admin/router/routeConfig.js
// module id = Cuer
// module chunks = 15